import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Argentinian() {
  return (
    <ApiCommunityDirectoryPage
      community="Argentinian"
      eyebrow="Argentinian community guide"
      title="Argentinian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Argentinian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Argentinian community guide?"
      modalIdPrefix="argentinian-directory"
    />
  );
}
